<template>
  <div class="loginPage d-flex align-center justify-center">
    <div v-if="currentScreen === 'login'" class="pa-10">
      <v-img class="ml-7" :src="require('@/assets/login/bluecor.png')" width="382px" height="333px"></v-img>
      <Input class="my-3" placeholder="Email" type="text" v-model="email" />
      <Input class="mb-3" placeholder="Senha" type="password" v-model="password" />
      <div class="d-flex justify-space-between mb-3">
        <span class="forgotPasswordText" @click="currentScreen = 'recovery'">Esqueceu sua senha?</span>
        <p v-if="error" class="errorMessage">*{{ errorMsg }}</p>
      </div>
      <Button text="Entrar" width="432" @click.native="login" />
      <p class="mt-3 text-center">
        <span
          class="activateAccount"
          @click="currentScreen = 'activation'"
        >Ativar conta de administrador</span>
      </p>
    </div>
    <div class="pa-10" v-if="currentScreen === 'recovery'">
      <v-card
        v-if="passwordRecoveryScreen === 'sendEmail'"
        class="card pa-3"
        height="240px"
        width="700px"
      >
        <v-card-title>
          <p class="cardTitle">Recuperação de senha</p>
        </v-card-title>
        <v-card-subtitle>
          <p class="cardDescription">
            Insira o e-mail da conta para enviarmos um código de recuperação de
            senha
          </p>
        </v-card-subtitle>
        <v-card-text>
          <v-row class="d-flex align-center">
            <v-col sm="8">
              <Input placeholder="E-mail" type="email" v-model="recovery.email" />
            </v-col>
            <v-col sm="2">
              <Button text="Enviar" width="152" @click.native="sendRecoveryEmail()" />
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <p>
            <span class="forgotPasswordText" @click="currentScreen = 'login'">Voltar</span>
            <span
              v-if="recoveryErrors.sendEmail"
              class="ml-3 errorMessage"
            >*{{ recoveryErrorsMsg.sendEmail }}</span>
          </p>
        </v-card-text>
      </v-card>

      <v-card
        v-if="passwordRecoveryScreen === 'sendCode'"
        class="card pa-3"
        height="240px"
        width="700px"
      >
        <v-card-title>
          <p class="cardTitle">Digite o código de recuperação</p>
        </v-card-title>
        <v-card-subtitle>
          <p class="cardDescription">
            Acesse o email {{ recovery.email }} e insira abaixo o código
            recebido
          </p>
        </v-card-subtitle>
        <v-card-text>
          <v-row class="d-flex align-center">
            <v-col sm="8">
              <v-text-field
                hide-details
                v-model="recovery.code"
                placeholder="Código"
                type="text"
                outlined
              ></v-text-field>
            </v-col>
            <v-col sm="2">
              <Button
                text="Validar"
                width="152"
                @click.native="passwordRecoveryScreen = 'newPassword'"
              />
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <p>
            <span class="forgotPasswordText" @click="passwordRecoveryScreen = 'sendEmail'">Reenviar</span>
          </p>
        </v-card-text>
      </v-card>
      <v-card
        v-if="passwordRecoveryScreen === 'newPassword'"
        class="card pa-3"
        height="400px"
        width="700px"
      >
        <v-card-title>
          <p class="cardTitle">Inserir nova senha</p>
        </v-card-title>
        <v-card-text>
          <v-row class="d-flex">
            <v-col sm="8" class="mb-2 pa-1">
              <Input placeholder="Nova senha" type="password" v-model="recovery.password" />
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row class="d-flex">
            <v-col sm="8" class="mb-2 pa-1">
              <Input
                placeholder="Confirmar nova senha"
                type="password"
                v-model="recovery.confirmPassword"
              />
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <p>
            <span class="forgotPasswordText" @click="passwordRecoveryScreen = 'sendCode'">Voltar</span>
            <span
              v-if="recoveryErrors.sendCode"
              class="errorMessage ml-3"
            >*{{ recoveryErrorsMsg.sendCode }}</span>
          </p>
          <Button text="Confirmar" width="152" @click.native="sendConfirmationCode()" />
        </v-card-text>
      </v-card>
    </div>
    <div class="pa-10" v-if="currentScreen === 'activation'">
      <v-card
        v-if="accountActivationScreen === 'validation'"
        class="card pa-3"
        height="357px"
        width="572px"
      >
        <v-card-title>
          <p class="cardTitle">Ativação da conta de administrador</p>
        </v-card-title>
        <v-card-subtitle>
          <p class="cardDescriptionSmall">
            Insira o e-mail cadastrado e o código recebido para a ativação da
            conta
          </p>
        </v-card-subtitle>
        <v-card-text>
          <v-text-field
            hide-details
            class="mb-5"
            placeholder="E-mail"
            type="email"
            v-model="activation.email"
            outlined
          ></v-text-field>
          <v-text-field
            hide-details
            class="mb-2"
            placeholder="Código"
            type="text"
            v-model="activation.code"
            outlined
          ></v-text-field>
          <v-row>
            <v-col class="d-flex justify-center">
              <v-btn
                outlined
                height="40"
                @click.native="currentScreen = 'login'"
                class="text-xs-center mr-3"
                color="#0012A6"
                width="152"
              >Voltar</v-btn>
              <Button
                @click.native="accountActivationScreen = 'setPassword'"
                class="text-xs-center"
                text="Verificar"
                width="152"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card
        v-if="accountActivationScreen === 'setPassword'"
        class="card pa-3"
        height="400px"
        width="480px"
      >
        <p style="height: 20px" class="mt-3 ml-4">
          <span
            v-if="activationErrors.sendCode"
            class="activationErrorMessage"
          >{{ activationErrorsMsg.sendCode }}</span>
        </p>
        <v-card-title style="margin-top: 20px;">
          <p class="cardTitle">Insira a sua senha</p>
        </v-card-title>
        <v-card-text>
          <v-text-field
            hide-details
            class="mb-5"
            placeholder="Senha"
            type="password"
            v-model="activation.password"
            outlined
          ></v-text-field>
          <v-text-field
            hide-details
            class="mb-2"
            placeholder="Confirmar senha"
            type="password"
            v-model="activation.confirmPassword"
            outlined
          ></v-text-field>
          <v-row>
            <v-col class="d-flex justify-center">
              <v-btn
                outlined
                height="40"
                @click.native="accountActivationScreen = 'validation'"
                class="text-xs-center mr-3"
                color="#0012A6"
                width="152"
              >Voltar</v-btn>
              <Button
                @click.native="activateAccount()"
                class="text-xs-center"
                text="Cadastrar"
                width="152"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Input from "@/components/atoms/Login/input";
import Button from "@/components/atoms/Login/button";
export default {
  components: {
    Input,
    Button
  },
  data() {
    return {
      email: "",
      password: "",
      error: false,
      errorMsg: "",
      currentScreen: "login",
      passwordRecoveryScreen: "sendEmail",
      accountActivationScreen: "validation",
      recovery: {
        email: "",
        code: "",
        password: "",
        confirmPassword: ""
      },
      recoveryErrors: {
        sendEmail: false,
        sendCode: false
      },
      recoveryErrorsMsg: {
        sendEmail: "",
        sendCode: ""
      },
      activation: {
        email: "",
        code: "",
        password: "",
        confirmPassword: ""
      },
      activationErrors: {
        sendEmail: false,
        sendCode: false
      },
      activationErrorsMsg: {
        sendEmail: "",
        sendCode: ""
      }
    };
  },
  methods: {
    login() {
      axios
        .post(`${process.env.VUE_APP_API_URL}/api/auth`, {
          email: this.email,
          password: this.password
        })
        .then(res => {
          const { token } = res.data.data;
          const { name, email, role } = res.data.data.user;
          if (token && role == 2) {
            this.$store.dispatch("saveToken", { name, email, token });
            axios
              .get(`${process.env.VUE_APP_API_URL}/api/admin/webapp`, {
                headers: {
                  Authorization: `Bearer ${this.$store.state.user.token}`
                }
              })
              .then(res => {
                this.$store.dispatch("setAccounts", {
                  accounts: res.data.data.users
                });
                this.$store.dispatch("setProcedures", {
                  procedures: res.data.data.procedureResults
                });
                this.$store.dispatch("setFilterOptions", {
                  procedures: res.data.data.filterOptions
                });
              })
              .then(() => {
                this.error = false;
                this.$router.push("/");
              });
          }
        })
        .catch(error => {
          this.error = true;
          if (error.response.status === 400 || error.response.status === 401)
            this.errorMsg = "Dados incorretos. Tente novamente.";
          else this.errorMsg = "Erro ao tentar efetuar login.";
        });
    },
    sendRecoveryEmail() {
      axios
        .put(
          `${process.env.VUE_APP_API_URL}/api/users/password/generate/code`,
          {
            email: this.recovery.email
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.user.token}`
            }
          }
        )
        .then(() => {
          this.recoveryErrors.sendEmail = false;
          this.passwordRecoveryScreen = "sendCode";
        })
        .catch(error => {
          this.recoveryErrors.sendEmail = true;
          if (error.response.status === 400)
            this.recoveryErrorsMsg.sendEmail =
              "Email incorreto. Tente novamente.";
          else
            this.recoveryErrorsMsg.sendEmail =
              "Erro ao enviar email. Tente novamente.";
        });
    },
    sendConfirmationCode() {
      if (this.recovery.password.length === 0) {
        this.recoveryErrors.sendCode = true;
        this.recoveryErrorsMsg.sendCode = "Campo de senha vazio";
      } else if (this.recovery.password.length < 6) {
        this.recoveryErrors.sendCode = true;
        this.recoveryErrorsMsg.sendCode =
          "Senha deve conter no mínimo 6 caracteres";
      } else if (this.recovery.password !== this.recovery.confirmPassword) {
        this.recoveryErrors.sendCode = true;
        this.recoveryErrorsMsg.sendCode = "Senhas inseridas não conferem.";
      } else {
        axios
          .put(
            `${process.env.VUE_APP_API_URL}/api/users/password/recovery`,
            {
              email: this.recovery.email,
              code: this.recovery.code,
              password: this.recovery.password
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.user.token}`
              }
            }
          )
          .then(() => {
            this.recovery.email = "";
            this.recovery.code = "";
            this.recoveryErrors.sendCode = false;
            this.passwordRecoveryScreen = "sendEmail";
            this.accountActivationScreen = "validation";
            this.currentScreen = "login";
          })
          .catch(error => {
            this.recoveryErrors.sendCode = true;
            if (error.response.status === 400 || error.response.status === 401)
              this.recoveryErrorsMsg.sendCode =
                "Erro ao enviar código. Tente novamente.";
            else
              this.recoveryErrorsMsg.sendEmail =
                "Erro ao enviar código. Tente novamente.";
          });
      }
    },
    activateAccount() {
      if (this.activation.password.length === 0) {
        this.activationErrors.sendCode = true;
        this.activationErrorsMsg.sendCode = "Senha não pode estra em branco";
      } else if (this.activation.password !== this.activation.confirmPassword) {
        this.activationErrors.sendCode = true;
        this.activationErrorsMsg.sendCode = "Senhas não conferem";
      } else {
        axios
          .put(
            `${process.env.VUE_APP_API_URL}/api/admin/account/activation`,
            {
              email: this.activation.email,
              code: this.activation.code,
              password: this.activation.password
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.user.token}`
              }
            }
          )
          .then(() => {
            this.activation.email = "";
            this.activation.code = "";
            this.activation.password = "";
            this.activation.confirmPassword = "";
            this.activationErrors.sendCode = false;
            this.activationErrorsMsg.sendCode = "";
            this.currentScreen = "login";
          })
          .catch(() => {
            this.activationErrors.sendCode = true;
            this.activationErrorsMsg.sendCode = "Erro de validação";
          });
      }
    }
  }
};
</script>

<style scoped>
.loginPage {
  height: 100%;
  background: url("~@/assets/login/background-heart.png");
}

.card {
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
}

.forgotPasswordText {
  font-family: Montserrat;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #0012a6;
  cursor: pointer;
  padding: 0px;
  margin: 0px;
}

.cardTitle {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #000000;
}

.cardDescription {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #000000;
}

.cardDescriptionSmall {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #424242;
}

.errorMessage {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: red;
  text-align: right;
  padding: 0px;
  margin: 0px;
}

.activateAccount {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  text-transform: uppercase;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #0012a6;
  cursor: pointer;
}

.activationErrorMessage {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.5px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #b71c1c;
}
</style>
